import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const ExamInsightsPrintsLazy = React.lazy(
	() => import(/* webpackChunkName : 'ExamInsightsPrints' */ './components')
);

export default (store) => [
	{
		path: 'home/insights/exams-insights/prints',
		element: <AsyncLoading component={<ExamInsightsPrintsLazy />} />,
	},
];
